// components/RestaurantStampActivity.js
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import Pagination from './Pagination';
const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  timeout: 5000,
});
const RestaurantStampActivity = () => {
  const { restaurantId } = useParams();
  const [stamps, setStamps] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [search, setSearch] = useState('');
  const [sortBy, setSortBy] = useState('lastStampDate');
  const [sortOrder, setSortOrder] = useState('desc');

  useEffect(() => {
    fetchStampActivity();
  }, [currentPage, search, sortBy, sortOrder]);

  const fetchStampActivity = async () => {
    try {
      const token = localStorage.getItem('ownerToken');

      const response = await api.get(
        `/restaurants/${restaurantId}/stamp-activity`,
        {
          params: { page: currentPage, search, sortBy, sortOrder },
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      setStamps(response.data.stamps);
      setTotalPages(response.data.totalPages);
    } catch (error) {
      toast.error('Failed to fetch stamp activity');
    }
  };

  return (
    <div className='p-6'>
      <h2 className='text-2xl font-bold mb-4'>Stamp Activity</h2>
      <input
        type='text'
        placeholder='Search by phone number'
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        className='w-full mb-4 p-2 border rounded'
      />
      <table className='w-full mb-4'>
        <thead>
          <tr>
            <th>Customer</th>
            <th>
              Total Stamps
              <button onClick={() => setSortBy('count')}>
                {sortBy === 'count' ? (sortOrder === 'asc' ? '↑' : '↓') : '⇵'}
              </button>
            </th>
            <th>
              Last Stamp Date
              <button onClick={() => setSortBy('lastStampDate')}>
                {sortBy === 'lastStampDate'
                  ? sortOrder === 'asc'
                    ? '↑'
                    : '↓'
                  : '⇵'}
              </button>
            </th>
          </tr>
        </thead>
        <tbody>
          {stamps.map((stamp) => (
            <tr key={stamp._id}>
              <td>{stamp.customer.phoneNumber}</td>
              <td>{stamp.count}</td>
              <td>{new Date(stamp.lastStampDate).toLocaleString()}</td>
            </tr>
          ))}
        </tbody>
      </table>
      <Pagination
        currentPage={currentPage}
        totalPages={totalPages}
        onPageChange={setCurrentPage}
      />
    </div>
  );
};

export default RestaurantStampActivity;
